import React from "react";

interface IcoProps {
    size?: number;
    color?: string;
}

const Ico: React.FC<IcoProps & { d?: string; children?: React.ReactNode }> = ({
                                                                                   d,
                                                                                   size = 16,
                                                                                   color = "currentColor",
                                                                                   children,
                                                                               }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
         strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round" style={{display: "block"}}>
        {d ? <path d={d}/> : children}
    </svg>
);

export const SiteIcon: React.FC<IcoProps> = (p) => (
    <Ico {...p}>
        <rect x="3" y="9" width="8" height="11" rx="1"/>
        <rect x="13" y="4" width="8" height="16" rx="1"/>
        <path d="M6 12h2M6 15h2M16 8h2M16 12h2M16 16h2"/>
    </Ico>
);

export const DeviceIcon: React.FC<IcoProps> = (p) => (
    <Ico {...p}>
        <rect x="4" y="3" width="16" height="18" rx="2"/>
        <path d="M8 7h5M8 11h5M8 15h3"/>
        <circle cx="16.5" cy="15" r="1.3" fill="currentColor" stroke="none"/>
    </Ico>
);

export const GroupIcon: React.FC<IcoProps> = (p) => (
    <Ico {...p}>
        <circle cx="12" cy="12" r="9"/>
        <path d="M12 12l4-2.5M12 7v0"/>
    </Ico>
);

export const SensorIcon: React.FC<IcoProps> = (p) => (
    <Ico {...p}>
        <circle cx="12" cy="12" r="9"/>
    </Ico>
);

export const ChevronIcon: React.FC<IcoProps> = (p) => (
    <Ico {...p} d="M9 6l6 6-6 6"/>
);

export const SearchIcon: React.FC<IcoProps> = (p) => (
    <Ico {...p}>
        <circle cx="11" cy="11" r="7"/>
        <path d="M21 21l-4-4"/>
    </Ico>
);
